import { CLEAR_SITE_DATA } from '../application';
import { SET_CREATING_BOOKMARK } from './actions';

const initialState = {
  bookmarks: {},
  loaded: false,
  isCreating: false,
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CREATING_BOOKMARK: {
      return { ...state, isCreating: action.isCreating };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        bookmarks: {},
        loaded: false,
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
